<div class="header">
    <p>Confirmar compra</p>
    <p (click)="close()" class="cr-pointer">X</p>
</div>
<div class="body animated fadeIn">
    <img [src]="buildGalleryImageUrl(projectData?.image)" alt="" class="img-s mt-4">
    <h3 class="text-center fw-bold cl-black fs-24 p-3 mt-2">Confirma tu inversión</h3>

    <div>
        <div class="d-flex align-items-center justify-content-between px-4 mb-2">
            <p class="m-0 fs-16 cl-grey">Participaciones a adquirir:</p>
            <p class="m-0 fs-16 cl-grey fw-bold">{{ projectData?.amount }}</p>
        </div>
        <div class="d-flex align-items-center justify-content-between px-4 my-2 mb-4">
            <p class="m-0 fs-16 cl-grey">Precio unitario:</p>
            <p class="m-0 fs-16 cl-grey fw-bold">${{ projectData?.partValue || 1000 | number }}</p>
        </div>
    </div>

    <hr class="m-auto d-block w-90">

    <div class="d-flex align-items-center justify-content-between px-4 mb-2 mt-4">
        <p class="m-0 fs-16 cl-black fw-bold">Inversión total</p>
        <p class="m-0 fs-16 cl-grey fw-bold">${{ projectData?.totalInvest | number }}</p>
    </div>

    <div class="d-flex align-items-center justify-content-around p-3 ">
        <div class="col-5">
            <button class="btn btn-white shadow" (click)="close()">Cancelar</button>
        </div>
        <div class="col-5">
            <button class="btn btn-primary-m shadow" (click)="next()">Invertir ahora</button>
        </div>
    </div>

    <p class="cl-grey fs-11 mb-2 mt-1 p-3 text-center">{{informativeTextPurchase}} {{ informativeTextBalanceAfterPurchase | number }}</p>

</div>
